export const GENDERS = ["MALE", "FEMALE", "NOT_SPECIFIED"];
